import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/LightIndicatorWarnings/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/LightIndicatorWarnings/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/LightIndicatorWarnings/GetById`, payload),
    Add: (payload) => Repository.post(`/api/LightIndicatorWarnings/Add`, payload),
    Edit: (payload) => Repository.post(`/api/LightIndicatorWarnings/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/LightIndicatorWarnings/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/LightIndicatorWarnings/ChangeStatus`, payload),
}
